import React from 'react'
import ModuleListItem from '../themes/template-components/ModuleListItem'

// Had to make this a class component to be able to use the react-to-print package
class LitlabModuleCard extends React.Component {
	render() {
		const { data } = this.props
		return (
			<div>
				<div className="flex flex-col bg-white">
					<span className="my-3 text-center text-3xl font-medium">Literature Lab Module</span>
					<div className="mb-4 text-center text-lg text-slate-400">
						<span>The Literature Lab Module includes the following:</span>
					</div>
					<ul className="list-checkmark mx-auto my-8">
						<ModuleListItem text="Teacher Guide" />
						{data.grade.split(' ')[1] === 'K' && (
							<>
								<ModuleListItem text="Professional Learning Resource" />
								<ModuleListItem text="Big Books" />
								<ModuleListItem text="Writer's Notebook" />
								<ModuleListItem text="Read-Aloud Immersion Collection" />
							</>
						)}
						{parseInt(data.grade.split(' ')[1]) === 1 && (
							<>
								<ModuleListItem text="Professional Learning Resource" />
								<ModuleListItem text="Read-Aloud Immersion Collection" />
								<ModuleListItem text="Word Study & Writer's Notebook" />
							</>
						)}
						{parseInt(data.grade.split(' ')[1]) <= 5 && parseInt(data.grade.split(' ')[1]) > 1 && <ModuleListItem text="Writer's Notebook" />}
						{parseInt(data.grade.split(' ')[1]) === 2 && (
							<>
								<ModuleListItem text="Read Aloud Collection" />
								<ModuleListItem text="Poetry Mini Text Set" />
								<ModuleListItem text="Narrative Mini Text Set" />
							</>
						)}
						{parseInt(data.grade.split(' ')[1]) === 3 && <ModuleListItem text="Class Sets of Two Magic Tree House Novels & Read-Alouds" />}
						{parseInt(data.grade.split(' ')[1]) > 3 && (
							<ModuleListItem text="Paired Core Texts: Class Sets of Two High-Interest Grade Level Texts for Shared Reading" />
						)}
						{parseInt(data.grade.split(' ')[1]) >= 3 && <ModuleListItem text="Hook Book Library" />}
						<ModuleListItem text="100 Book Challenge Rotating Classroom Libraries" />
						<ModuleListItem text="Teacher Resource Kit" />
						<ModuleListItem text={`${data.grade.includes('Spanish') ? 'ENIL' : 'IRLA'} Home-Practice Cards`} />
						<ModuleListItem text="Take-Home Book Bags" />
					</ul>
				</div>
			</div>
		)
	}
}

export default LitlabModuleCard
